import React, {  useState, useEffect, useRef, useCallback } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import { TailSpin } from "react-loader-spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";

import Add_venueowner from "../../Components/Admin_components/add_venueowner.js";
import Delete_venueowner from "../../Components/Admin_components/delete_venueowner.js";
import Update_instructor from "../../Components/Admin_components/update_instructor.js";

import "../../Api/apiUrls";
import { getAdminVenueOwner } from "../../Api/apiUrls";

// Debounce function to limit rapid firing of events
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function Venue_Owner() {
  // Data states
  const [allPayouts, setAllPayouts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({});
  
  // Loading states
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(1);

  // Modal and selection states
  const [modalAdd_venueownerIsOpen, setAdd_venueownerModalIsOpen] =
    useState("");
  const [modalDelete_venueownerIsOpen, setDelete_venueownerIsOpen] =
    useState(false);
    const [modalUpdate_venueownerIsOpen, setUpdate_venueownerModalIsOpen] =
    useState("");
  const [selectedInstructorId, setSelectedInstructorId] = useState(null);
  const [venueowner, setInstructor] = useState([]);
  const [selectedInstructor, setSelectedInstructor] = useState([]);

  // Filter and search states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const tableContainerRef = useRef();
  const searchInputRef = useRef();

  const Status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const [selectedStatus, setSelectedStatus] = useState("All");


  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption.value);
    setPage(1);
    setAllPayouts([]);
  };

  const handleSearchInputChange = (event) => {
    const newValue = event.target.value;
    setSearchQuery(newValue);
    
    if (newValue === "") {
      setSearchTerm("");
      setPage(1);
      setAllPayouts([]);
      fetchPassPayout(1, true);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchTerm(searchQuery);
    setPage(1);
    setAllPayouts([]);
    fetchPassPayout(1, true);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit(e);
    }
  };

  
  const closeAdd_venueowner = () => {
    setAdd_venueownerModalIsOpen(false);
  };
  const openDelete_venueowner = (venueownerId) => {
    setSelectedInstructorId(venueownerId);
    closeDelete_venueowner();
    setDelete_venueownerIsOpen(true);
  };

  const closeDelete_venueowner = () => {
    setDelete_venueownerIsOpen(null);
  };

  const handleEditClick = (venueowner) => {
    setSelectedInstructor(venueowner);
    setUpdate_venueownerModalIsOpen(true);
  };

  const fetchPassPayout = useCallback(async (pageNum = 1, reset = false) => {
    // Don't fetch if we're trying to go beyond total pages
    if (pagination.total_pages && pageNum > pagination.total_pages) {
      setHasMore(false);
      return;
    }
    
    setIsFetching(true);
    try {
      let url = `${getAdminVenueOwner}?page=${pageNum}&page_size=50`;
      
      if (selectedStatus !== "All") {
        url += `&status=${selectedStatus}`;
      }
      
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      
      if (!data.data || !data.data.users) {
        throw new Error("Invalid data format from API");
      }
      
      const newUsers = data.data.users;
      
      if (reset || pageNum === 1) {
        setAllPayouts(newUsers);
      } else {
        setAllPayouts(prev => [...prev, ...newUsers]);
      }
      
      setPagination(data.data.pagination || {});
      setTotalItems(data.data.pagination?.total_items || 0);
      
      const currentPage = data.data.pagination?.current_page || 1;
      const totalPages = data.data.pagination?.total_pages || 1;
      setHasMore(currentPage < totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllPayouts([]);
      setTotalItems(0);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  }, [selectedStatus, searchTerm, pagination.total_pages]);

  useEffect(() => {
    fetchPassPayout(page);
  }, [page, fetchPassPayout]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container || isFetching || !hasMore) return;

    const handleScroll = debounce(() => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollHeight - (scrollTop + clientHeight) < 50) {
        setPage(prev => {
          const nextPage = prev + 1;
          // Check if nextPage exceeds total pages
          if (pagination.total_pages && nextPage > pagination.total_pages) {
            return prev;
          }
          return nextPage;
        });
      }
    }, 200);

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [isFetching, hasMore, pagination.total_pages]);


  const formatCreatedAt = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    return createdAtDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const showingCount = allPayouts.length;
  const isFiltered = searchTerm || selectedStatus !== "All";

  return (
    <div>
      <Header />
      {modalAdd_venueownerIsOpen && (
        <Add_venueowner onClose={closeAdd_venueowner} />
      )}
      {modalUpdate_venueownerIsOpen && (
          <Update_instructor
            open={modalUpdate_venueownerIsOpen}
            onClose={() => setUpdate_venueownerModalIsOpen(false)}
            instructor={selectedInstructor}
          />
        )}
      {modalDelete_venueownerIsOpen && (
          <Delete_venueowner
            open={modalDelete_venueownerIsOpen}
            onClose={() => setDelete_venueownerIsOpen(false)}
            venueowner={selectedInstructor}
          />
        )}

      
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Venue Provider</h1>
        </div>
        <section className="section">
          <div className="card p-2">
            <div className="parent col-md-12 row mt-2">
              <div className="col-md-8 d-flex flex-wrap">
                <form onSubmit={handleSearchSubmit} className="d-flex">
                  <div className="child mr-2 mb-2">
                    <input
                      ref={searchInputRef}
                      onChange={handleSearchInputChange}
                      value={searchQuery}
                      type="text"
                      className="form-control"
                      placeholder="Search all fields..."
                    />
                  </div>
                  <div className="child mr-2 mb-2">
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                      disabled={isFetching}
                    >
                      {isFetching ? 'Searching...' : 'Search'}
                    </button>
                  </div>
                </form>
                <div className="child mr-2 mb-2" style={{ minWidth: "200px" }}>
                  <Select
                    options={Status}
                    placeholder="Status"
                    onChange={handleStatusChange}
                    value={Status.find(option => option.value === selectedStatus)}
                    isDisabled={isFetching}
                  />
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-end mb-2">
                <div className="child">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setAdd_venueownerModalIsOpen(true)}
                  >
                    <i className="bi bi-person-add"></i> Add Venue Owner
                  </button>
                </div>
              </div>
            </div>

            <div className="table-responsive" ref={tableContainerRef} style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {isLoading ? (
                <div className="text-center my-5">
                  <TailSpin color="#0d6efd" width={50} />
                </div>
              ) : allPayouts.length > 0 ? (
                <>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Sr. No.</th>
                        <th scope="col">Details</th>
                        <th scope="col">Followers</th>

                        <th scope="col">Bank Detail</th>
                        <th scope="col">Listing</th>
                        <th scope="col">Location</th>

                        <th scope="col">Status</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allPayouts.map((venueowner, index) => (
                        <tr key={`${venueowner.id}-${index}`}>
                          <th scope="row">{index + 1}</th>
                          <td>
                            {venueowner.name || "--"}
                            <br />
                            {venueowner.mobileNumber || "--"}
                            <br />
                            {venueowner.email || "--"}
                            <br />
                          </td>
                          
                          <td>
                            {venueowner.followers_count || "--"}
                            <br />
                          </td>

                          <td>
                            {venueowner.bank_account_number || "--"}
                            <br />
                            {venueowner.bank_name || "--"}
                            <br />
                            {venueowner.bank_ifsc_code || "--"}
                            <br />
                            {venueowner.account_holder_name || "--"}
                            <br />
                          </td>
                          <td>
                            {venueowner.listings_count || "--"}
                            <br />
                          </td>
                          <td>
                            {venueowner.city || "--"}
                            <br />
                          </td>
                          <td>
                            {venueowner.status || "--"}
                            <br />
                          </td>
                          <td>{formatCreatedAt(venueowner.created_at)}</td>
                          <td>
                            <div className="social-links mt-2">
                            <a
                              onClick={() => handleEditClick(venueowner)}
                              >
                                <i className="bi bi-pencil"></i>
                              </a>
                              &nbsp;
                              <a
                                onClick={() => openDelete_venueowner(venueowner.id)}
                              >
                                <i className="bi bi-trash"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {isFetching && (
                    <div className="text-center py-3">
                      <TailSpin color="#0d6efd" width={50} />
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-4">
                  <h4>No Venue Provider data found</h4>
                  <p>Try adjusting your search or filters</p>
                </div>
              )}
            </div>

            <div className="p-3 bg-dark text-white rounded-bottom">
              Showing {showingCount} of {totalItems} total payouts
              {hasMore && !isFetching && !isFiltered && " - scroll to load more"}
              {hasMore && isFiltered && (
                <button 
                  className="btn btn-sm btn-light ml-2"
                  onClick={() => {
                    const nextPage = page + 1;
                    if (pagination.total_pages && nextPage <= pagination.total_pages) {
                      setPage(nextPage);
                    }
                  }}
                  disabled={isFetching || (pagination.total_pages && page >= pagination.total_pages)}
                >
                  {isFetching ? 'Loading...' : 'Load More'}
                </button>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Venue_Owner;